import { IFpayParams } from "@/api/apiRsp/IFWalletRsp";
import { AmountMultiplierConversion } from "@/Core/utils/currencyDealCenter";

export function isRechargeAmountValid(
  value: unknown,
  rule: Pick<IFpayParams, "decide" | "gears" | "min" | "max"> | undefined,
  currencyType: string,
  serverCurrencyType?: string,
) {
  const amount = Number(value);
  if (!rule || !Number.isFinite(amount) || amount <= 0) return false;
  const money = AmountMultiplierConversion(amount, { currencyType, serverCurrencyType });
  if (rule.decide === 1) {
    return !!rule.gears?.some((gear) => Number(gear) === money);
  }
  return !(money < rule.min || money > rule.max);
}
